import { CarrierContract } from '~api/carrier_contracts';

import { Card, ListLayout } from '@ingrid/luterkort-react';

import { EntityReference } from '~src/components/EntityReference/EntityReference';
import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  contract: Pick<CarrierContract, 'contract_id' | 'name' | 'description'>;
}

export function BasicInfo({ contract }: Props) {
  const { t } = useTranslation();

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.basicInformation')}</Card.Header>

      <Card.Content>
        <ListLayout.Column>
          <EntityReference
            label={t('carrierContracts.details.field.common.contract_id')}
            value={contract.contract_id}
          />

          <ListLayout.Row>
            <ListLayout.Stack>
              <ListLayout.SecondaryText>{t('common.name')}</ListLayout.SecondaryText>
              <ListLayout.PrimaryText>{contract.name}</ListLayout.PrimaryText>
            </ListLayout.Stack>
          </ListLayout.Row>

          <ListLayout.Row>
            <ListLayout.Stack>
              <ListLayout.SecondaryText>{t('common.description')}</ListLayout.SecondaryText>
              <ListLayout.PrimaryText>{contract.description ?? '-'}</ListLayout.PrimaryText>
            </ListLayout.Stack>
          </ListLayout.Row>
        </ListLayout.Column>
      </Card.Content>
    </Card.Wrapper>
  );
}
